import { Textarea } from './textarea'
import React from 'react'
import { css, cx } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import clipboardCopy from 'clipboard-copy'
import { codeCss } from '../text'

const cssMainContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const cssHeaderContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 5px;
`

const cssCopyLink = css`
  font-size: 12px;
  cursor: pointer;
`

const cssCopyTextArea = cx(
  codeCss,
  css`
    width: 100%;
  `
)

interface ClipboardTextareaProps {
  readonly labelId?: string
  readonly value: string
  readonly classNameTextArea?: string
  readonly onCopy?: () => void
  readonly e2eTestId?: string
}
export function ClipboardTextarea({
  labelId,
  value,
  classNameTextArea,
  onCopy,
  e2eTestId
}: ClipboardTextareaProps) {
  const cssTextArea = classNameTextArea
    ? cx(cssCopyTextArea, classNameTextArea)
    : cssCopyTextArea
  return (
    <div className={cssMainContainer}>
      <div className={cssHeaderContainer}>
        {labelId && <FormattedMessage id={labelId} />}
        <a
          className={cssCopyLink}
          onClick={async () => {
            await clipboardCopy(value)
            if (onCopy) {
              onCopy()
            }
          }}
        >
          <FormattedMessage id="action_copy" />
        </a>
      </div>
      <Textarea
        required
        value={value}
        disabled
        classNameTextArea={cssTextArea}
        e2eTestId={e2eTestId}
      />
    </div>
  )
}
